import React from 'react'

export default function HeatMarker ({heat, itemNumber}) {
  return (
    <li className={`heatMarker heat${heat}`}>Question {itemNumber}</li>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/TestTaking/HeatMarker.js